import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { TaskTitleControllerApi } from "../../../services";
import {
    DGT_Pagination,
    getConfigObject,
    getPageIndexWhileSearch,
    useBaseContent,
} from "../../../utils/utils";

export type OptionData = {
  name: string;
  uuid: string;
};

type TaskOptionsProps = {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useTaskOptionsList = (
  props: TaskOptionsProps
): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(props.pagination.page);
  const pageIndex = getPageIndexWhileSearch({
    pagination: props.pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = props.gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "task-options-list",
      pageIndex,
      props.gridSorting,
      props.status,
      props.archive,
      props.searchString,
      props.xTENANTID,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new TaskTitleControllerApi(getConfigObject())
        .getAllDepartments(
          pageIndex,
          props.pagination.pageSize,
          sortBy,
          sortDirect,
          props.status,
          props.archive,
          props.searchString,
          props.xTENANTID
        )
        .then((res) => res?.data),
  });
};
